import { VIEWS } from './constants';

const View = (props) => {
  const { active, ...restProps } = props;

  return VIEWS[active](restProps);
};

export default View;
